import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { QUERY_KEY_SETTINGS_ADMIN_PANEL } from '@/lib/api/constants';

type ImportUserPayload = {
  key: string;
};

async function importUser(payload: ImportUserPayload) {
  const response = await axiosInstance.post('/config-api/user/createServiceUser', {
    key: payload.key,
  });
  return response.data;
}

export function useMutationImportUser(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importUser,
    onSuccess: () => {
      // Invalidate and refetch users list
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_ADMIN_PANEL, 'users', companyId],
      });
    },
  });
}

